// External Dependencies
import { useLocation } from 'react-router-dom';

// Internal Dependencies
import DataGridContainer from 'components/shared/TableDataGrid/DataGridContainer';
import TableDataGridServerSide, {
  useParsedDataGridQueryString,
} from 'components/shared/TableDataGrid/ServerSide';
import { useGetAllInvoices } from 'hooks/api/invoices';
import TableDataGridZeroResultsState from 'components/shared/TableDataGrid/TableDataGridZeroResultsState';
import { Subtitle } from 'components/shared';

// Local Dependencies
import { useColumns } from './hooks';

// Local Variables
const handleTableClickRow = (id: string) => `/invoices/${id}`;

// Component Definition
const InvoicesTable = () => {
  const { search } = useLocation();

  const columns = useColumns();

  const {
    filters,
    pagination,
    sort,
  } = useParsedDataGridQueryString(search, {
    columns,
    mapAllKeysToSnakeCase: false,
  });

  const {
    data: invoicesData,
    isLoading,
  } = useGetAllInvoices({
    filters,
    limit: pagination?.pageSize ?? 100,
    page: pagination?.page ?? 1,
    sort,
  });

  return (
    <>
      <Subtitle>Invoices</Subtitle>
      <DataGridContainer>
        <TableDataGridServerSide
          clickRowTo={handleTableClickRow}
          columns={columns}
          components={{
            NoRowsOverlay: TableDataGridZeroResultsState,
          }}
          fullCount={invoicesData?.data.fullCount ?? 0}
          loading={isLoading}
          rows={invoicesData?.data.data ?? null}
          tableResource="invoices"
          withSearch
          zeroStateMessage="No invoices found."
        />
      </DataGridContainer>
    </>
  );
};

export default InvoicesTable;
